/**
 * External dependencies
 */
import React, { memo } from 'react';
import PageView from '@naruto/naruto-components/src/layer/v1/PageView';

/**
 * Internal dependencies
 */
import useMappedRoute from '@naruto/bgdapp/src/hooks/useMappedRoute';
import Header from './Header';
import SideBar from './SideBar';

function MainView(): React.ReactElement {
  /* Global & local State */
  const dom = useMappedRoute([]);

  /* Main */
  return (
    <PageView
      headerHeight={0}
      headerSx={{
        display: {
          xss: 'block',
          xs: 'block',
          sm: 'block',
          md: 'block',
          lg: 'none'
        },
        height: {
          xss: '56px',
          xs: '56px',
          sm: '56px',
          md: '56px',
          lg: '0px'
        }
      }}
      containerSx={{
        height: {
          xss: `calc(100% - 56px)`,
          xs: `calc(100% - 56px)`,
          sm: `calc(100% - 56px)`,
          md: '100%'
        }
      }}
      header={<Header />}
      side={<SideBar />}
    >
      {dom}
    </PageView>
  );
}

export default memo(MainView);
